export default {
  title: "Consulta Bases"
  , button: { email: "Enviar por correo" }
  , tabla: {
    idFileTransaction: "Folio Archivo"
    , fechaRegistro: "Fecha Registro"
    , nombreArchivo: "Nombre Archivo"
    , tipo: "Tipo"
    , vendor: "Vendor"
    , cantidadRegistros: "Cantidad Registros"
    , status: "Estatus"
    , payfac: "PAYFAC"
  }
  , filters: {
    subtipo: "Sub-Tipo"
    , fecha: "Fecha Registro"
    , payfac: "Payfac"
    , tipo: "Tipo"
    , vendor: "Vendor"
    , status: "Estatus"
  }
  , fragment: {
    detalle: "Detalle"
    , exclusiones: "Exclusiones"
  }
  , detalle: {
    clave: "Clave"
    , campana: "Campaña"
    , se: "SE10"
    , seller: "Seller"
    , cuit: "CUIT"
    , nombre: "Nombre"
    , razonSocial: "Razón Social"
    , codigoIndustrial: "Código Industrial"
    , acuerdo: "Acuerdo"
    , subIndustria: "Sub-Industria"
    , direccion: "Dirección"
    , altura: "Altura"
    , localidad: "Localidad"
    , provincia: "Provincia"
    , cp: "C.P."
    , telefono: "Teléfono"
    , email: "E-Mail"
    , banco: "Banco"
    , pos: "POS"
    , ahora12: "Ahora12"
    , benefPref: "Beneficio"
    , fechaFinPromo: "Fecha Fin Promo"
    , vendor: "Vendor"
    , tipoContacto: "Tipo Contacto"
    , flag: "Flag"
    , status: "Estatus"
    , payfac: "PAYFAC"
  }
  , exclusiones: {
    clave: "Clave"
    , campana: "Campaña"
    , se: "SE10"
    , status: "Estatus"
    , vendor: "Vendor"
  }
  , errors: {
    BD8000: { text: "Ocurrió un error en el Listado de Bases" }
    , WS8000: { text: "Ocurrió un error en el Listado de Bases" }
    , JS8000: { text: "Ocurrió un error en el Listado de Bases" }
    , CR8000: { text: "Ocurrió un error en el Listado de Bases" }
    , MS8000: { text: "Error en el envío manual de emails" }
    , UK_Base: { text: "Ya existe un registro con la misma descripción" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/bases/base.js